import { memo, type FC, type MouseEventHandler } from 'react';

import Icons from '../../../../Elements/Icons/index.ts';
import { Preset } from './styled.ts';

interface PresetItemProps {
  title: string;
  isActive: boolean;
  onClick: MouseEventHandler<HTMLDivElement>;
  dataTestId?: string;
  isCustom?: boolean;
  range?: boolean;
}

export const PresetItem: FC<PresetItemProps> = memo(function PresetItem({ title, isActive, onClick, dataTestId, isCustom, range }) {
  return (
    <Preset onClick={onClick} $isActive={isActive} $isCustom={isCustom} $range={range} data-testid={dataTestId}>
      {title}
      {isActive && <Icons.Checkmark size={20} dataTestId={dataTestId ? `${dataTestId}-checkmark` : undefined} />}
    </Preset>
  );
});
